import DataBed from "@/services/DataBed";

import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import { appModule } from "./app";


@Module({ store, dynamic: true, name: "storeBed" })
class BedStore extends VuexModule {
  bed = [];
  bangsal = [];
  pasienAll = [];
  rekapBed = [];
  pasien={};
  booking=[];
  bookingRm=[];
  bookingUnit=[];
  akses={};
  loading= true
  loadingBangsal= true
  loadingPasien= true

  @Mutation SET_BED(bed: []) {
    this.bed = bed;
  }
  @Mutation SET_BANGSAL(bangsal: []) {
    this.bangsal = bangsal;
  }
  @Mutation SET_PASIEN_ALL(pasienAll: []) {
    this.pasienAll = pasienAll;
  }
  @Mutation SET_REKAP_BED(rekapBed: []) {
    this.rekapBed = rekapBed;
  }
  @Mutation SET_PASIEN(pasien: {}) {
    this.pasien = pasien;
  }
  @Mutation SET_BOOKING_RM(bookingRm: []) {
    this.bookingRm = bookingRm;
  }
  @Mutation SET_BOOKING(booking: []) {
    this.booking = booking;
  }
  @Mutation SET_BOOKING_UNIT(bookingUnit: []) {
    this.bookingUnit = bookingUnit;
  }
  @Mutation SET_AKSES(akses: {}) {
    this.akses = akses;
  }
  @Mutation SET_LOADING(loading) {
    this.loading = loading;
  }
  @Mutation SET_LOADING_BANGSAL(loadingBangsal) {
    this.loadingBangsal = loadingBangsal;
  }
  @Mutation SET_LOADING_PASIEN(loadingPasien) {
    this.loadingPasien = loadingPasien;
  }

  @Action actBedByUnit(unitID) {
    this.SET_BED([]);
    this.SET_LOADING(true)
    const dt = DataBed.getBedByUnit(unitID)
    dt.then(dt => {
      const bed = dt.data;
      this.SET_LOADING(false)
      this.SET_BED(bed);
    });
  }
  @Action actBangsalByUnit(unitID) {
    this.SET_BANGSAL([]);
    this.SET_LOADING_BANGSAL(true)
    const dt = DataBed.getBedByUnit(unitID)
    dt.then(dt => {
      const bed = dt.data;
      this.SET_LOADING_BANGSAL(false)
      this.SET_BANGSAL(bed);
    });
  }

  @Action actPasienAll() {
    this.SET_PASIEN_ALL([]);
    this.SET_LOADING_PASIEN(true)
    const dt = DataBed.getPasienAll()
    dt.then(dt => {
      const pasienAll = dt.data;
      this.SET_LOADING_PASIEN(false)
      this.SET_PASIEN_ALL(pasienAll);
    });
  }

  @Action actBookingUnit(unitID) {
    // this.SET_LOADING(true)
    const dt = DataBed.getBookingUnit(unitID)
    dt.then(dt => {
      const bookingUnit = dt.data;
      console.log("aaa",bookingUnit)
      // this.SET_LOADING(false)
      this.SET_BOOKING_UNIT(bookingUnit);
    });
  }

  @Action actBookingRm(rm) {
    const dt = DataBed.getBookingByRM(rm)
    dt.then(dt => {
      const bookingRm = dt.data;
      if(bookingRm.length>0){
        this.SET_BOOKING_RM(bookingRm);
      } else {
        alert("Tidak Ada Data Pemesanan dengan RM: "+rm)
      }
    });
  }
  
  @Action actRekapBed() {
    // this.SET_LOADING(true)
    const dt = DataBed.getRekapBed()
    dt.then(dt => {
      const rekapBed = dt.data;
      // this.SET_LOADING(false)
      this.SET_REKAP_BED(rekapBed);
    });
  }
  @Action actPasien(rm) {
    const dt = DataBed.getPasienByRM(rm)
    dt.then(dt => {
      if(dt.status==0){

        appModule.sendErrorAlert(dt.message);
      }
      const pasien = dt.data;
      this.SET_PASIEN(pasien);
    });
  }
  @Action actAkses(dt) {
      this.SET_AKSES(dt);
      // role 1 = Admin (bisa buka semua)
      // role 2 = Pelayanan (tambah, edit, hapus Bed)
      // role 3 = admisi (tambah, hapus Pemesanan ; pasien masuk dan mutasi)
      // role 4 = kasir (pulangkan pasien)
  }

  @Action actClearPasien() {
      this.SET_PASIEN({});
  }

  @Action actClearBed() {
    this.SET_BED([]);
    this.SET_LOADING(false)
  }

  @Action actBooking(param) {
    if(param["kelasID"]){
      const dt = DataBed.getBooking(param["unitID"],param["kelasID"])
      dt.then(dt => {
        const booking = dt.data;
        this.SET_BOOKING(booking);
      });
    }
  }

  @Action actClearBooking() {
    this.SET_BOOKING([]);
    this.SET_BOOKING_RM([]);
  }
}

export const storeBed= getModule(BedStore);
